export const GET_ADMINS = "GET_ADMINS";
export const GET_ADMINS_SUCCESS = "GET_ADMINS_SUCCESS";
export const GET_ADMINS_FAIL = "GET_ADMINS_FAIL";

export const POST_ADD_ADMIN = "POST_ADD_ADMIN";
export const POST_ADD_ADMIN_SUCCESS = "POST_ADD_ADMIN_SUCCESS";
export const POST_ADD_ADMIN_FAIL = "POST_ADD_ADMIN_FAIL";

export const DELETE_ADMIN = "DELETE_ADMIN";
export const DELETE_ADMIN_SUCCESS = "DELETE_ADMIN_SUCCESS";
export const DELETE_ADMIN_FAIL = "DELETE_ADMIN_FAIL";

export const CREATE_MANAGER = "CREATE_MANAGER";
export const CREATE_MANAGER_SUCCESS = "CREATE_MANAGER_SUCCESS";
export const CREATE_MANAGER_FAIL = "CREATE_MANAGER_FAIL";

export const GET_WORKSPACE_DETAILS = "GET_WORKSPACE_DETAILS";
export const GET_WORKSPACE_DETAILS_SUCCESS = "GET_WORKSPACE_DETAILS_SUCCESS";
export const GET_WORKSPACE_DETAILS_FAIL = "GET_WORKSPACE_DETAILS_FAIL";

export const UPDATE_WORKSPACE_DETAILS = "UPDATE_WORKSPACE_DETAILS";
export const UPDATE_WORKSPACE_DETAILS_SUCCESS = "UPDATE_WORKSPACE_DETAILS_SUCCESS";
export const UPDATE_WORKSPACE_DETAILS_FAIL = "UPDATE_WORKSPACE_DETAILS_FAIL";

export const UPDATE_WORKSPACE_USER = "UPDATE_WORKSPACE_USER";
export const UPDATE_WORKSPACE_USER_SUCCESS = "UPDATE_WORKSPACE_USER_SUCCESS";
export const UPDATE_WORKSPACE_USER_FAIL = "UPDATE_WORKSPACE_USER_FAIL";

export const DELETE_WORKSPACE_USER = "DELETE_WORKSPACE_USER";
export const DELETE_WORKSPACE_USER_SUCCESS = "DELETE_WORKSPACE_USER_SUCCESS";
export const DELETE_WORKSPACE_USER_FAIL = "DELETE_WORKSPACE_USER_FAIL";

export const TOGGLE_ACCOUNT_STATUS = "TOGGLE_ACCOUNT_STATUS";
export const TOGGLE_ACCOUNT_STATUS_SUCCESS = "TOGGLE_ACCOUNT_STATUS_SUCCESS";
export const TOGGLE_ACCOUNT_STATUS_FAIL = "TOGGLE_ACCOUNT_STATUS_FAIL";
